import React from 'react';

export const TwitterLogo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="47"
      height="46"
      viewBox="0 0 47 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" width="46" height="46" rx="23" fill="#26A7DE" />
      <path
        d="M31.4297 19.4375C31.4297 19.6328 31.4297 19.7891 31.4297 19.9844C31.4297 25.4141 27.3281 31.625 19.7891 31.625C17.4453 31.625 15.2969 30.9609 13.5 29.7891C13.8125 29.8281 14.125 29.8672 14.4766 29.8672C16.3906 29.8672 18.1484 29.2031 19.5547 28.1094C17.7578 28.0703 16.2344 26.8984 15.7266 25.2578C16 25.2969 16.2344 25.3359 16.5078 25.3359C16.8594 25.3359 17.25 25.2578 17.5625 25.1797C15.6875 24.7891 14.2812 23.1484 14.2812 21.1562V21.1172C14.8281 21.4297 15.4922 21.5859 16.1562 21.625C15.0234 20.8828 14.3203 19.6328 14.3203 18.2266C14.3203 17.4453 14.5156 16.7422 14.8672 16.1562C16.8984 18.6172 19.9453 20.2578 23.3438 20.4531C23.2656 20.1406 23.2266 19.8281 23.2266 19.5156C23.2266 17.25 25.0625 15.4141 27.3281 15.4141C28.5 15.4141 29.5547 15.8828 30.3359 16.7031C31.2344 16.5078 32.1328 16.1562 32.9141 15.6875C32.6016 16.6641 31.9766 17.4453 31.1172 17.9531C31.9375 17.875 32.7578 17.6406 33.4609 17.3281C32.9141 18.1484 32.2109 18.8516 31.4297 19.4375Z"
        fill="white"
      />
    </svg>
  );
};
